<template>
<div class="chapter">
<div class="inner_page">
<p> </p>
<p> </p>
<div class="_idGenObjectStyleOverride-1" id="_idContainer006">
<p class="Normal ParaOverride-1"><span class="CharOverride-8">For Kamal and Ahmed</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?03d4fc27